import { Link } from "react-router-dom";
import { Filter, X } from "lucide-react";
import { fmtNum } from "@/lib/api";

export const ACTION_LABELS = {
  no_weight: "In-stock in-scope materials missing net weight",
  sold_ni: "In-stock in-scope products sold to Northern Ireland",
  sold_ie: "In-stock in-scope products sold to Ireland",
  sold_eu: "In-stock in-scope products sold to other EU",
  in_stock: "In-stock in-scope untraceable products",
  no_contact: "Suppliers of in-stock in-scope products with no contact",
  not_submitted: "Suppliers of in-stock in-scope products not invited / not submitted",
  eu_mill_no_ref: "EU mill purchases of in-stock products missing an export reference",
  assess: "Supplier assessments to approve or reassess",
  dds_needed: "Last month's in-stock in-scope deliveries that need a DDS (no drafts generated yet — generate them in the DDS register)",
  clearance: "Customers buying in-stock in-scope products into NI/IE/EU with clearance not confirmed",
};

export const ActionBanner = ({ action, total, clearTo }) => (action ? (
  <div className="mb-4 flex flex-wrap items-center gap-3 rounded-xl border border-[#D52B3B]/20 bg-[#D52B3B]/5 px-4 py-2.5 text-sm text-slate-800" data-testid="action-filter-banner">
    <Filter className="h-4 w-4 text-[#D52B3B]" />
    <span>Dashboard action: <b>{ACTION_LABELS[action] || action}</b>{total != null && <> · <span data-testid="action-filter-total">{fmtNum(total)}</span> item(s)</>}</span>
    <Link to={clearTo} className="ml-auto inline-flex items-center gap-1 text-xs text-slate-500 hover:text-slate-900" data-testid="action-filter-clear"><X className="h-3.5 w-3.5" />Clear</Link>
  </div>
) : null);
